import { createReducer } from 'services/reduxHelpers'
import { globalTypes } from 'reduxModules/actions/GlobalActions'

/* ------------- Initial State ------------- */

export const initialState = {
  carriers: [],
  buses: [],
  drivers: []
}

/* ------------- Hookup Reducers To Types ------------- */

const setDriverAttempt = ({ drivers }, { data: { id, value } }) => ({
  drivers: drivers.map(driver => {
    if (driver.id === id) {
      return {
        ...driver,
        label: value
      }
    } else {
      return driver
    }
  })
})

const setBusAttempt = ({ buses }, { data: { id, value, field } }) => ({
  buses: buses.map(bus => {
    if (bus.id === id) {
      return {
        ...bus,
        [field]: value
      }
    } else {
      return bus
    }
  })
})

export default createReducer(initialState, {
  [globalTypes.GET_CARRIERS_SUCCESS]: (_, { data }) => ({
    carriers: data
  }),

  [globalTypes.GET_BUSES_SUCCESS]: (_, { data }) => ({
    buses: data
  }),

  [globalTypes.GET_DRIVERS_SUCCESS]: (_, { data }) => ({
    drivers: data
  }),

  [globalTypes.SET_DRIVER_ATTEMPT]: setDriverAttempt,

  [globalTypes.SET_BUS_ATTEMPT]: setBusAttempt,
  [globalTypes.DELETE_BUS_SUCCESS]: ({ buses }, { data: { id } }) => ({
    buses: buses.filter(bus => bus.id !== id)
  }),
  [globalTypes.CREATE_BUS_SUCCESS]: ({ buses }, { data }) => ({
    buses: [
      ...buses,
      data
    ]
  }),
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/GlobalReducer.js